"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.blobDecoder = exports.boolStringDecoder = exports.mustBeNumDecoder = exports.numStringDecoder = exports.NumType = exports.boundedArrayDecoder = exports.dateInstanceDecoder = exports.dateParser = exports.dateDecoder = exports.isoDateDecoder = exports.isoTimestampDecoder = exports.optionalIsoTimestampDecoder = exports.unixTimestampDecoder = exports.javascriptTimestampDecoder = exports.timeZoneDecoder = exports.addressDecoder = exports.emailDecoder = exports.intDecoder = exports.voidDecoder = exports.nullDecoder = void 0;
const D = __importStar(require("schemawax"));
const parsers_1 = require("../parsers");
exports.nullDecoder = D.unknown.andThen((value) => {
    if (value === null) {
        return null;
    }
    else {
        throw new Error(`Provided value ${value} is not null.`);
    }
});
exports.voidDecoder = D.unknown.andThen(() => {
    return undefined;
});
exports.intDecoder = D.number.andThen((value) => {
    if (Number.isSafeInteger(value)) {
        return value;
    }
    else {
        throw new Error(`Provided number ${value} is not an integer.`);
    }
});
exports.emailDecoder = D.string.andThen((value) => {
    if (value.match("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$") === null) {
        throw new Error(`Provided email '${value}' is not a valid email.`);
    }
    else {
        return value;
    }
});
exports.addressDecoder = D.string.andThen((value) => {
    if (value.match(/^0x[0-9A-F]{40}$/i) === null) {
        throw new Error(`Provided address '${value}' is not a valid blockchain address.`);
    }
    else {
        return value;
    }
});
exports.timeZoneDecoder = D.string.andThen((value) => {
    try {
        Intl.DateTimeFormat(undefined, { timeZone: value });
        return value;
    }
    catch (exception) {
        throw new Error(`Provided time zone '${value}' is not valid.`);
    }
});
exports.javascriptTimestampDecoder = D.number.andThen((value) => {
    return (0, parsers_1.javascriptTimestampParser)(value);
});
exports.unixTimestampDecoder = D.number.andThen((value) => {
    return (0, parsers_1.unixTimestampParser)(value);
});
exports.optionalIsoTimestampDecoder = D.unknown.andThen((value) => {
    if (!value || value === "") {
        return null;
    }
    return exports.isoTimestampDecoder.forceDecode(value);
});
exports.isoTimestampDecoder = D.string.andThen((value) => {
    return (0, parsers_1.iso8601TimestampParser)(value);
});
exports.isoDateDecoder = D.string.andThen((value) => {
    return (0, parsers_1.iso8601DateParser)(value);
});
exports.dateDecoder = D.string.andThen((date) => {
    const dt = new Date(date);
    const ts = dt.getTime();
    if (isNaN(ts)) {
        throw new Error("Invalid date", { cause: date });
    }
    return dt;
});
exports.dateParser = D.unknown.andThen((date) => {
    if (!(date instanceof Date)) {
        throw new Error("Invalid date", { cause: date });
    }
    return date;
});
exports.dateInstanceDecoder = D.createDecoder({
    forceDecode: (d) => {
        if (!(d instanceof Date)) {
            throw new Error(`Date '${d}' is not an instance of date`);
        }
        return d;
    },
});
const boundedArrayDecoder = ({ boundaries: { maxLength, minLength } = {
    maxLength: Infinity,
    minLength: 0,
}, elem, }) => D.array(elem).andThen((arr) => {
    if (arr.length < minLength || arr.length > maxLength) {
        throw new Error("boundedArrayDecoder: Invalid array dimensions", {
            cause: arr,
        });
    }
    return arr;
});
exports.boundedArrayDecoder = boundedArrayDecoder;
var NumType;
(function (NumType) {
    NumType["INT"] = "int";
    NumType["FLOAT"] = "float";
})(NumType || (exports.NumType = NumType = {}));
const numStringDecoder = (kind) => D.string.andThen((data) => {
    let result = NaN;
    switch (kind) {
        case NumType.INT:
            result = (0, parsers_1.parseIntSafe)(data);
            break;
        case NumType.FLOAT:
            result = (0, parsers_1.parseFloatSafe)(data);
            break;
    }
    if (isNaN(result)) {
        throw new Error("numStringDecoder: Bad number recived", { cause: data });
    }
    return result;
});
exports.numStringDecoder = numStringDecoder;
const mustBeNumDecoder = (kind) => D.unknown.andThen((data) => {
    let result = NaN;
    if (typeof data === "number") {
        return data;
    }
    if (typeof data !== "string") {
        throw new Error(`mustBeNumDecoder: Invalid input data`, { cause: data });
    }
    switch (kind) {
        case NumType.INT:
            result = (0, parsers_1.parseIntSafe)(data.toString());
            break;
        case NumType.FLOAT:
            result = (0, parsers_1.parseFloatSafe)(data);
            break;
    }
    if (isNaN(result)) {
        throw new Error("mustBeNumDecoder: Bad number recieved", { cause: data });
    }
    return result;
});
exports.mustBeNumDecoder = mustBeNumDecoder;
exports.boolStringDecoder = D.string.andThen((data) => (data === "true" ? true : false));
exports.blobDecoder = D.createDecoder({
    forceDecode: (data) => {
        D.checkDefined(data);
        const condition = (data) => data instanceof Blob;
        if (!condition(data)) {
            throw new D.DecoderError(`This is not a Blob`);
        }
        return data;
    },
});
//# sourceMappingURL=decoders.js.map